enum AuditLogAction {
  View = 'view',
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
}

const entityActionNames = {
  [AuditLogAction.View]: 'Visualização',
  [AuditLogAction.Create]: 'Criação',
  [AuditLogAction.Update]: 'Edição',
  [AuditLogAction.Delete]: 'Remoção',
};

export const toAuditLogAction = (
  entity: string | AuditLogAction
): AuditLogAction | undefined => {
  const value = entity.toLowerCase();
  return (Object.values(AuditLogAction) as string[]).includes(value)
    ? (value as AuditLogAction)
    : undefined;
};

export const getAuditLogName = (action: string | AuditLogAction) => {
  const value = toAuditLogAction(action);
  return !value ? action : entityActionNames[value];
};

const entityActions = Object.entries(entityActionNames).map(([key, value]) => ({
  action: key,
  name: value,
}));

export { entityActions };
